// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Blocker_wrapper__2o_Wv","inner":"Blocker_inner__1JTjp","text":"Blocker_text__32G4W"};